/**
 * SHADOW of @plone/volto SortOn.
 *
 * The design uses per-column header sort in the tabular listing variation
 * (wired through the shadowed SearchBlockView -> ListingBody -> TableListing),
 * so the SearchBlock's standalone "Sorted on <field>" + asc/desc widget is
 * redundant. Render nothing to remove it from every browse page.
 */
const SortOn = () => null;

export default SortOn;
